<template>
  <div class="product-canvas d-block w-auto" ref="canvas">
    <product-configuration>
      <svg
        version="1.1"
        id="product"
        width="100%"
        :height="$runtimeEnvironment.isMobileOnly ? 140 : height"
        slot-scope="{
          cableColor,
          fiberCount,
          plugTypeSideA,
          plugColorSideA,
          plexSideA,
          plugTypeSideB,
          plugColorSideB,
          plexSideB,
          cableDiameter,
          bendProtectionA,
          bendProtectionB,
        }"
        :viewBox="`0 0 ${width} ${height}`"
        font-family="'Merriweather Sans';'MerriweatherSans-Regular';sans-serif"
        v-cloak
      >
        <defs>
          <clipPath id="snippet">
            <rect x="0" y="0" width="240" :height="height" />
          </clipPath>

          <clipPath id="snippet-b">
            <rect :x="width - 240" y="0" width="260" :height="height" />
          </clipPath>

          <clipPath id="everything">
            <rect x="0" y="0" :width="width" :height="height" />
          </clipPath>
        </defs>
        <!--
        <g>
          <text>
            {{ plugTypeSideA }}{{ plexSideA }}
            {{
              calculatePlugCount({
                fiberCount,
                plugType: plugTypeSideA,
                plex: plexSideA,
              })
            }}
          </text>
        </g>
        -->
        <g v-if="fiberCount === null" class="no-fiber-count-hint">
          <no-fiber-count-hint
            v-if="false"
            :svg-width="width"
            :svg-height="height"
            :svg-small-size-breakpoint="568"
          />
          <base-cable
            v-if="$route.name === 'patch-cord'"
            v-bind="{
              fiberCount: '1',
              svgWidth: width,
              svgHeight: height,
              svgPadding: horizontalPadding,
              svgCladdingMargin: claddingMargin,
              svgCloakMargin: cloakMargin,
            }"
            style="opacity: 0.3"
          />
          <base-cable
            v-if="['trunk', 'breakout'].includes($route.name)"
            v-bind="{
              fiberCount: '12',
              svgWidth: width,
              svgHeight: height,
              svgPadding: horizontalPadding,
              svgCladdingMargin: claddingMargin,
              svgCloakMargin: cloakMargin,
            }"
            style="opacity: 0.3"
          />
        </g>
        <g v-else clip-path="url(#everything)" class="clipping">
          <base-cable
            v-bind="{
              cableColor,
              fiberCount: getEffectiveFiberCountForCable(fiberCount, plugTypeSideA, plugTypeSideB),
              svgWidth: width,
              svgHeight: height,
              svgPadding: horizontalPadding,
              svgCladdingMargin: claddingMargin,
              svgCloakMargin: cloakMargin,
              isPigtail,
              thickness,
              plugSideACount: calculatePlugCount({
                fiberCount,
                plugType: plugTypeSideA,
                plex: plexSideA,
              }),
              plugSideBCount: calculatePlugCount({
                fiberCount,
                plugType: plugTypeSideB,
                plex: plexSideB,
              }),
              plexSideA,
              plexSideB,
            }"
          />
          <g class="side-a">
            <!-- plugs side-a -->
            <g class="plugs-a" v-if="plugTypeSideA">
              <g v-if="getEffectiveFiberCountForCable(fiberCount, plugTypeSideA, plugTypeSideB) === '1'">
                <rect
                  class="fiber-overlay"
                  :x="horizontalPadding + fiberOverlayPadding.x"
                  :y="
                    height / 2 -
                    offsets[`${plugTypeSideA}Plug`].y -
                    fiberOverlayPadding.y
                  "
                  :height="
                    2 *
                    (offsets[`${plugTypeSideA}Plug`].y + fiberOverlayPadding.y)
                  "
                  :width="claddingMargin + cloakMargin"
                  fill="white"
                />
                <component
                  :is="`${
                    plugTypeSideA.indexOf('FC') === 0
                      ? 'FC'
                      : plugTypeSideA.indexOf('FSMA') === 0
                      ? 'FSMA905Rändel'
                      : plugTypeSideA
                  }Plug`"
                  :x="horizontalPadding + offsets[`${plugTypeSideA}Plug`].x"
                  :y="height / 2"
                  :plug-color="plugColorSideA"
                />
                <bend-protection
                  v-if="bendProtectionA"
                  :x="horizontalPadding + claddingMargin + cloakMargin + 5"
                  :y="height / 2"
                  :color="bendProtectionA.colorTop"
                />
              </g>

              <g v-if="getEffectiveFiberCountForCable(fiberCount, plugTypeSideA, plugTypeSideB) === '2'">
                <g v-if="plugTypeSideA === 'URM NG P2'">
                  <g v-if="bendProtectionA">
                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 40
                      } ${height / 2}) scale(1.4 1.4)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="horizontalPadding + fiberOverlayPadding.x"
                    :y="
                      height / 2 -
                      offsets[`${plugTypeSideA}Plug`].y -
                      fiberOverlayPadding.y
                    "
                    :height="
                      2 *
                      (offsets[`${plugTypeSideA}Plug`].y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`UrmP2Plug`"
                    :transform="`translate(${horizontalPadding} ${
                      height / 2 + 14
                    }) scale(1.3 1.3)`"
                    :plug-color="plugColorSideA"
                  />
                </g>
                <g v-else-if="plugTypeSideA === 'MDC'">
                  <g v-if="bendProtectionA">
                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 50
                      } ${height / 2}) scale(1.4 1.4)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="horizontalPadding + fiberOverlayPadding.x"
                    :y="
                      height / 2 -
                      offsets[`${plugTypeSideA}Plug`].y -
                      fiberOverlayPadding.y
                    "
                    :height="
                      2 *
                      (offsets[`${plugTypeSideA}Plug`].y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`MDCPlug`"
                    :transform="`translate(${horizontalPadding - 5} ${
                      height / 2 - 20
                    }) scale(-1 1) rotate(90)`"
                    :plug-color="plugColorSideA"
                  />
                </g>
                <g v-else-if="plugTypeSideA === 'SN EZ-Flip'">
                  <g v-if="bendProtectionA && bendProtectionA == 'afsv' ">
                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 50
                      } ${height / 2}) scale(1.4 1.4)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="horizontalPadding"
                    :y="height / 2 - 58"
                    :width="svgWidth - horizontalPadding * 2"
                    :height="cloakMargin"
                  />
                  <component
                    :is="`SNEZFlipPlug`"
                    :transform="`translate(${117} ${
                      height / 2 - 58
                    }) scale(-1 1) rotate(0)`"
                    :plug-color="plugColorSideA"
                  />
                </g>
                <g v-else-if="plugTypeSideA === 'CS'">
                  <g v-if="bendProtectionA">
                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 50
                      } ${height / 2}) scale(1.4 1.4)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="horizontalPadding + fiberOverlayPadding.x"
                    :y="
                      height / 2 -
                      offsets[`${plugTypeSideA}Plug`].y -
                      fiberOverlayPadding.y
                    "
                    :height="
                      2 *
                      (offsets[`${plugTypeSideA}Plug`].y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`CsPlug`"
                    :transform="`translate(${horizontalPadding - 5} ${
                      height / 2 - 11
                    }) scale(-1 1) rotate(90)`"
                    :plug-color="plugColorSideA"
                  />
                </g>
                <g
                  v-else-if="
                    ['MTP', 'mtp'].includes(plugTypeSideA)
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 50
                      } ${height / 2}) scale(1.4 1.4)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="horizontalPadding + fiberOverlayPadding.x"
                    :y="
                      height / 2 -
                      (
                        offsets[`${plugTypeSideA}Plug`] ||
                        offsets['MTP12Plug']
                      ).y -
                      fiberOverlayPadding.y
                    "
                    :height="
                      2 *
                      ((
                        offsets[`${plugTypeSideA}Plug`] ||
                        offsets['MTP12Plug']
                      ).y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`MTP12Plug`"
                    :transform="`translate(${horizontalPadding + 15} ${
                      height / 2
                    }) scale(0.35 0.35)`"
                    :plug-type="plugTypeSideA"
                    :plex="plexSideA"
                    :plug-color="plugColorSideA"
                    ferrule-type="Keramik"
                    politur="APC"
                    farbe="grün"
                    clip-type="ohne"
                  />
                </g>
                <g v-else>
                  <rect
                    class="fiber-overlay"
                    :x="horizontalPadding + fiberOverlayPadding.x"
                    :y="
                      height / 2 -
                      offsets[`${plugTypeSideA}Plug`].y -
                      fiberOverlayPadding.y
                    "
                    :height="
                      2 *
                      (offsets[`${plugTypeSideA}Plug`].y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`${
                      plugTypeSideA.indexOf('FC') === 0
                        ? 'FC'
                        : plugTypeSideA === 'URM NG P2'
                        ? 'UrmP2'
                        : plugTypeSideA
                    }Plug`"
                    :x="horizontalPadding + offsets[`${plugTypeSideA}Plug`].x"
                    :y="height / 2 - offsets[`${plugTypeSideA}Plug`].y"
                    :plug-color="plugColorSideA"
                    :clip="plexSideA === 'dx'"
                  />
                  <component
                    :is="`${
                      plugTypeSideA.indexOf('FC') === 0 ? 'FC' : plugTypeSideA
                    }Plug`"
                    :x="horizontalPadding + offsets[`${plugTypeSideA}Plug`].x"
                    :y="height / 2 + offsets[`${plugTypeSideA}Plug`].y"
                    :plug-color="plugColorSideA"
                    :clip="plexSideA === 'dx'"
                  />

                  <sc-clip
                    v-if="plexSideA === 'dx' && plugTypeSideA === 'SC'"
                    :transform="`translate(${
                      horizontalPadding + claddingMargin + cloakMargin - 6
                    } ${height / 2 - 47 / 2}) scale(-1 1)`"
                    :color="plugColorSideA"
                  />
                  <lc-clip
                    v-if="plexSideA === 'dx' && plugTypeSideA === 'LC'"
                    :transform="`translate(${
                      horizontalPadding + claddingMargin + cloakMargin - 6 - 76
                    } ${height / 2 + 18.5}) rotate(-90)`"
                    :color="plugColorSideA"
                  />

                  <bend-protection
                    v-if="bendProtectionA"
                    :transform="`translate(${
                      horizontalPadding + claddingMargin + cloakMargin + 7
                    } ${height / 2})`"
                    :scale-x="1.5"
                    :scale-y="1.6"
                    :color="bendProtectionA.colorTop"
                  />
                  <g v-if="plexSideA && plexSideA.indexOf('Secure') > 0">
                    <circle
                      class="lc-secure-clip"
                      cx="0"
                      cy="0"
                      r="16"
                      fill="#d1230c"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 31
                      } ${height / 2})`"
                    />
                    <lc-clip
                      v-if="plugTypeSideA === 'LC'"
                      :transform="`translate(${horizontalPadding - 20} ${
                        height / 2 + 19
                      }) rotate(-90)`"
                      :color="`rot`"
                    />
                  </g>
                  <clip-tab
                    v-if="plexSideA && plexSideA.endsWith('Tab')"
                    :transform="`translate(${horizontalPadding + 110} ${
                      height / 2 - 8
                    })`"
                  />
                  <lc-uniboot-clip
                    v-if="
                      plexSideA &&
                      plexSideA.indexOf('Uniboot') === 0 &&
                      plexSideA.indexOf('Secure') === -1
                    "
                    :transform="`translate(${horizontalPadding + 40} ${
                      height / 2 - 17.5
                    }) scale(3.8 3.8)`"
                    :color="plugColorSideA"
                  />
                </g>
              </g>

              <g v-if="getEffectiveFiberCountForCable(fiberCount, plugTypeSideA, plugTypeSideB) === '2x1'">
                <rect
                  class="fiber-overlay"
                  :x="horizontalPadding + fiberOverlayPadding.x"
                  :y="
                    height / 2 -
                    offsets[`${plugTypeSideA}Plug`].y -
                    fiberOverlayPadding.y
                  "
                  :height="
                    2 *
                    (offsets[`${plugTypeSideA}Plug`].y + fiberOverlayPadding.y)
                  "
                  :width="claddingMargin + cloakMargin"
                  fill="white"
                />
                <component
                  :is="`${
                    plugTypeSideA.indexOf('FC') === 0
                      ? 'FC'
                      : plugTypeSideA.indexOf('FSMA') === 0
                      ? 'FSMA905Rändel'
                      : plugTypeSideA
                  }Plug`"
                  :x="horizontalPadding + offsets[`${plugTypeSideA}Plug`].x"
                  :y="height / 2 - offsets[`${plugTypeSideA}Plug`].y"
                  :plug-color="plugColorSideA"
                  :clip="plexSideA === 'dx'"
                />
                <component
                  :is="`${
                    plugTypeSideA.indexOf('FC') === 0
                      ? 'FC'
                      : plugTypeSideA.indexOf('FSMA') === 0
                      ? 'FSMA905Rändel'
                      : plugTypeSideA
                  }Plug`"
                  :x="horizontalPadding + offsets[`${plugTypeSideA}Plug`].x"
                  :y="height / 2 + offsets[`${plugTypeSideA}Plug`].y"
                  :plug-color="plugColorSideA"
                  :clip="plexSideA === 'dx'"
                />

                <g v-if="bendProtectionA">
                  <bend-protection
                    :x="horizontalPadding + claddingMargin + cloakMargin + 3"
                    :y="
                      height / 2 -
                      12.5 +
                      ([
                        'ST',
                        'FC',
                        'SC',
                        'FC Narrow Key',
                        'FSMA 905 Rändel',
                      ].includes(plugTypeSideA)
                        ? 0
                        : 3)
                    "
                    :color="bendProtectionA.colorBottom"
                  />
                  <bend-protection
                    :x="horizontalPadding + claddingMargin + cloakMargin + 3"
                    :y="
                      height / 2 +
                      12.5 -
                      ([
                        'ST',
                        'FC',
                        'SC',
                        'FC Narrow Key',
                        'FSMA 905 Rändel',
                      ].includes(plugTypeSideA)
                        ? 0
                        : 4)
                    "
                    :color="bendProtectionA.colorTop"
                  />
                </g>

                <sc-clip
                  v-if="plexSideA === 'dx' && plugTypeSideA === 'SC'"
                  :transform="`translate(${
                    horizontalPadding + claddingMargin + cloakMargin - 4
                  } ${height / 2 - 44 / 2}) scale(-1 1)`"
                  :color="plugColorSideA"
                />
                <lc-clip
                  v-if="plexSideA === 'dx' && plugTypeSideA === 'LC'"
                  :transform="`translate(${horizontalPadding - 20} ${
                    height / 2 + 18.5
                  }) rotate(-90)`"
                  :color="plugColorSideA"
                />
              </g>

              <g
                v-if="
                  [
                    '4',
                    '8',
                    '12',
                    '16',
                    '24',
                    '3x8',
                    '4x8',
                    '6x8',
                    '8x8',
                    '12x8',
                    '16x8',
                    '2x12',
                    '4x12',
                    '6x12',
                    '8x12',
                    '12x12',
                    '16x8',
                    '8x2',
                    '16x2',
                    '24x2',
                  ].includes(fiberCount) || (!isNaN(fiberCount) && parseInt(fiberCount) >= 4)
                "
              >
                <g
                  v-if="
                    ['E2000', 'LC'].includes(plugTypeSideA) &&
                    (plexSideA === 'sx' || !plexSideA)
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [48, 80, 136, 168]"
                    :key="`plug-a-${yOffset}`"
                    :is="`${plugTypeSideA}Plug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${horizontalPadding} ${yOffset}) rotate(-90) ${
                      plugTypeSideA === 'E2000'
                        ? 'scale(.6 .6)'
                        : 'scale(.8 .8)'
                    }`"
                    :plug-color="plugColorSideA"
                  />
                </g>
                <g
                  v-if="
                    ['FC', 'FC Narrow Key'].includes(plugTypeSideA) &&
                    plexSideA === 'sx'
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [52, 84, 140, 172]"
                    :key="`plug-a-${yOffset}`"
                    :is="`${
                      plugTypeSideA.indexOf('FC') === 0 ? 'FC' : plugTypeSideA
                    }Plug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${horizontalPadding} ${yOffset}) rotate(-90) scale(.8 .8)`"
                    :plug-color="plugColorSideA"
                    :clip="plexSideA === 'dx'"
                  />
                </g>
                <g
                  v-if="
                    ['FSMA 905 Rändel'].includes(plugTypeSideA) &&
                    plexSideA === 'sx'
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [67, 99, 154, 186]"
                    :key="`plug-a-${yOffset}`"
                    :is="`FSMA905RaendelPlug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${horizontalPadding} ${yOffset}) rotate(-90) scale(.7 .7)`"
                    :plug-color="plugColorSideA"
                    :clip="plexSideA === 'dx'"
                  />
                </g>
                <g v-if="['ST'].includes(plugTypeSideA) && plexSideA === 'sx'">
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [70, 101, 158, 189]"
                    :key="`plug-a-${yOffset}`"
                    :is="`${
                      plugTypeSideA.indexOf('FC') === 0 ? 'FC' : plugTypeSideA
                    }Plug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${horizontalPadding} ${yOffset}) rotate(-90) scale(.7 .7)`"
                    :plug-color="plugColorSideA"
                    :clip="plexSideA === 'dx'"
                  />
                </g>
                <g v-if="['DIN'].includes(plugTypeSideA) && plexSideA === 'sx'">
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [47, 78.5, 135.5, 167.5]"
                    :key="`plug-a-${yOffset}`"
                    :is="`DINPlug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${horizontalPadding} ${yOffset}) rotate(-90) scale(.7 .7)`"
                    :plug-color="plugColorSideA"
                    :clip="plexSideA === 'dx'"
                  />
                </g>
                <g v-if="['SC'].includes(plugTypeSideA) && plexSideA === 'sx'">
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [49, 81, 137, 169]"
                    :key="`plug-a-${yOffset}`"
                    :is="`${
                      plugTypeSideA.indexOf('FC') === 0 ? 'FC' : plugTypeSideA
                    }Plug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${horizontalPadding} ${yOffset}) rotate(-90) ${
                      plugTypeSideA === 'SC' ? 'scale(.6 .6)' : ''
                    }`"
                    :plug-color="plugColorSideA"
                    :clip="plexSideA === 'dx'"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P8'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 1
                  "
                >
                  <bend-protection
                    v-if="bendProtectionA"
                    :x="horizontalPadding + 80"
                    :y="height / 2"
                    :color="bendProtectionA.colorTop"
                  />
                  <component
                    :is="`UrmP8Plug`"
                    :transform="`translate(${horizontalPadding} ${
                      height / 2 + 19
                    })`"
                    :plug-color="plugColorSideA"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P8'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 72, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :x="horizontalPadding + 30"
                      :y="yOffset"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [53, 85, 141, 173]"
                    :key="`plug-a-${yOffset}`"
                    :is="`UrmP8Plug`"
                    :transform="`translate(${horizontalPadding} ${yOffset}) scale(.65 .65)`"
                    :plug-color="plugColorSideA"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P8'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) == 3
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 72, 128]"
                      :key="`bp-a-${yOffset}`"
                      :x="horizontalPadding + 30"
                      :y="yOffset"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [53, 85, 141]"
                    :key="`plug-a-${yOffset}`"
                    :is="`UrmP8Plug`"
                    :transform="`translate(${horizontalPadding} ${yOffset}) scale(.65 .65)`"
                    :plug-color="plugColorSideA"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P2'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${2 * horizontalPadding}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />

                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } 71.5) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />

                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } 128) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />

                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } 160) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  <component
                    :is="`UrmP2Plug`"
                    :transform="`translate(${horizontalPadding} ${
                      2 * horizontalPadding + 12
                    })`"
                    :plug-color="plugColorSideA"
                  />

                  <component
                    :is="`UrmP2Plug`"
                    :transform="`translate(${horizontalPadding} ${
                      height / 2 - (horizontalPadding - 3)
                    })`"
                    :plug-color="plugColorSideA"
                  />

                  <component
                    :is="`UrmP2Plug`"
                    :transform="`translate(${horizontalPadding} ${
                      height / 2 + (2 * horizontalPadding - 1)
                    })`"
                    :plug-color="plugColorSideA"
                  />

                  <component
                    :is="`UrmP2Plug`"
                    :transform="`translate(${horizontalPadding} ${
                      height - (horizontalPadding + 9)
                    })`"
                    :plug-color="plugColorSideA"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P2'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } 71.5) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />

                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } 128) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <component
                    :is="`UrmP2Plug`"
                    :transform="`translate(${horizontalPadding} ${
                      height / 2 - (horizontalPadding - 3)
                    })`"
                    :plug-color="plugColorSideA"
                  />

                  <component
                    :is="`UrmP2Plug`"
                    :transform="`translate(${horizontalPadding} ${
                      height / 2 + (2 * horizontalPadding - 1)
                    })`"
                    :plug-color="plugColorSideA"
                  />
                </g>

                <g
                  v-if="
                    ['LC'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4 &&
                    plexSideA === 'dx'
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="(yOffset, i) in [
                        35, 45, 66.5, 76.5, 123, 133, 155, 165,
                      ]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="
                        bendProtectionA.colorTop !==
                          bendProtectionA.colorBottom && i % 2 === 0
                          ? bendProtectionA.colorBottom
                          : bendProtectionA.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.6 .6) rotate(-90)`"
                    />
                    <lc-clip
                      v-if="plugTypeSideA === 'LC'"
                      :transform="`translate(${horizontalPadding - 12} ${
                        yOffset + 11
                      }) scale(.6 .6) rotate(-90)`"
                      :color="plugColorSideA"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['LC'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2 &&
                    plexSideA === 'dx'
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="(yOffset, i) in [66.5, 76.5, 123, 133]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="
                        bendProtectionA.colorTop !==
                          bendProtectionA.colorBottom && i % 2 === 0
                          ? bendProtectionA.colorBottom
                          : bendProtectionA.colorTop
                      "
                    />
                  </g>

                  <g v-for="yOffset in [72, 128]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.6 .6) rotate(-90)`"
                    />
                    <lc-clip
                      v-if="plugTypeSideA === 'LC'"
                      :transform="`translate(${horizontalPadding - 12} ${
                        yOffset + 11
                      }) scale(.6 .6) rotate(-90)`"
                      :color="plugColorSideA"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['E2000'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4 &&
                    plexSideA === 'dx'
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="(yOffset, i) in [
                        35, 45, 66.5, 76.5, 123, 133, 155, 165,
                      ]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="
                        bendProtectionA.colorTop !==
                          bendProtectionA.colorBottom && i % 2 === 0
                          ? bendProtectionA.colorBottom
                          : bendProtectionA.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.5 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.5 .6) rotate(-90)`"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['E2000'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2 &&
                    plexSideA === 'dx'
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="(yOffset, i) in [66.5, 76.5, 123, 133]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="
                        bendProtectionA.colorTop !==
                          bendProtectionA.colorBottom && i % 2 === 0
                          ? bendProtectionA.colorBottom
                          : bendProtectionA.colorTop
                      "
                    />
                  </g>

                  <g v-for="yOffset in [72, 128]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.5 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.5 .6) rotate(-90)`"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['SC'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4 &&
                    plexSideA === 'dx'
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="(yOffset, i) in [
                        35, 45, 66.5, 76.5, 123, 133, 155, 165,
                      ]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="
                        bendProtectionA.colorTop !==
                          bendProtectionA.colorBottom && i % 2 === 0
                          ? bendProtectionA.colorBottom
                          : bendProtectionA.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [39, 71, 127, 159]"
                    :key="`bp-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="20"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset - 13
                      })`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.4 .4) rotate(-90)`"
                    />

                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + 14
                      }) scale(.4 .4) rotate(-90)`"
                    />
                    <sc-clip
                      v-if="plugTypeSideA === 'SC'"
                      :transform="`translate(${horizontalPadding + 25} ${
                        yOffset - 13
                      }) scale(.6 .6)`"
                      :color="plugColorSideA"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['SC'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2 &&
                    plexSideA === 'dx'
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="(yOffset, i) in [66.5, 76.5, 123, 133]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="
                        bendProtectionA.colorTop !==
                          bendProtectionA.colorBottom && i % 2 === 0
                          ? bendProtectionA.colorBottom
                          : bendProtectionA.colorTop
                      "
                    />
                  </g>

                  <g v-for="yOffset in [71, 127]" :key="`bp-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="20"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset - 13
                      })`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.4 .4) rotate(-90)`"
                    />

                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + 14
                      }) scale(.4 .4) rotate(-90)`"
                    />
                    <sc-clip
                      v-if="plugTypeSideA === 'SC'"
                      :transform="`translate(${horizontalPadding + 25} ${
                        yOffset - 13
                      }) scale(.6 .6)`"
                      :color="plugColorSideA"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['LC'].includes(plugTypeSideA) &&
                    plexSideA &&
                    plexSideA.indexOf('Tab') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.6 .6) rotate(-90)`"
                    />
                    <clip-tab
                      v-if="plexSideA && plexSideA.indexOf('Tab') > 0"
                      :transform="`translate(${horizontalPadding + 35} ${
                        yOffset - 6
                      }) scale(.75 .75)`"
                    />
                    <lc-uniboot-clip
                      v-if="plexSideA && plexSideA.indexOf('Uniboot') === 0"
                      :transform="`translate(${horizontalPadding + 20} ${
                        yOffset - 11
                      }) scale(2.3 2.3)`"
                      :color="plugColorSideA"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideA) &&
                    plexSideA &&
                    plexSideA.indexOf('Secure') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.6 .6) rotate(-90)`"
                    />
                    <circle
                      class="lc-secure-clip"
                      cx="0"
                      cy="0"
                      r="10"
                      fill="#d1230c"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 5
                      } ${yOffset})`"
                    />
                    <lc-clip
                      v-if="plugTypeSideA === 'LC'"
                      :transform="`translate(${horizontalPadding - 12} ${
                        yOffset + 11
                      }) scale(.6 .6) rotate(-90)`"
                      :color="`rot`"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideA) &&
                    plexSideA &&
                    plexSideA.indexOf('Tab') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g v-for="yOffset in [72, 128]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.6 .6) rotate(-90)`"
                    />
                    <clip-tab
                      v-if="plexSideA && plexSideA.indexOf('Tab') > 0"
                      :transform="`translate(${horizontalPadding + 35} ${
                        yOffset - 6
                      }) scale(.75 .75)`"
                    />
                    <lc-uniboot-clip
                      v-if="plexSideA && plexSideA.indexOf('Uniboot') === 0"
                      :transform="`translate(${horizontalPadding + 20} ${
                        yOffset - 11
                      }) scale(2.3 2.3)`"
                      :color="plugColorSideA"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideA) &&
                    plexSideA &&
                    plexSideA.indexOf('Secure') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g v-for="yOffset in [72, 128]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.6 .6) rotate(-90)`"
                    />
                    <circle
                      class="lc-secure-clip"
                      cx="0"
                      cy="0"
                      r="10"
                      fill="#d1230c"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 5
                      } ${yOffset})`"
                    />
                    <lc-clip
                      v-if="plugTypeSideA === 'LC'"
                      :transform="`translate(${horizontalPadding - 12} ${
                        yOffset + 11
                      }) scale(.6 .6) rotate(-90)`"
                      :color="`rot`"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideA) &&
                    plexSideA &&
                    plexSideA.indexOf('PRO') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.6 .6) rotate(-90)`"
                    />
                    <lc-uniboot-clip
                      v-if="plexSideA && plexSideA.indexOf('Uniboot') === 0"
                      :transform="`translate(${horizontalPadding + 20} ${
                        yOffset - 11
                      }) scale(2.3 2.3)`"
                      :color="plugColorSideA"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideA) &&
                    plexSideA &&
                    plexSideA.indexOf('PRO') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 12
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g v-for="yOffset in [72, 128]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + (plugTypeSideA === 'LC' ? 12 : 14)
                      }) scale(.6 .6) rotate(-90)`"
                    />
                    <clip-tab
                      v-if="plexSideA && plexSideA.indexOf('Tab') > 0"
                      :transform="`translate(${horizontalPadding + 35} ${
                        yOffset - 6
                      }) scale(.75 .75)`"
                    />
                    <lc-uniboot-clip
                      v-if="plexSideA && plexSideA.indexOf('Uniboot') === 0"
                      :transform="`translate(${horizontalPadding + 20} ${
                        yOffset - 11
                      }) scale(2.3 2.3)`"
                      :color="plugColorSideA"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['MDC'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [28, 60, 116, 148]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + 4
                      })`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 -.6) rotate(-90)`"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['MDC'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g v-for="yOffset in [60, 116]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + 4
                      })`"
                    />
                    <component
                      :is="`${plugTypeSideA}Plug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 -.6) rotate(-90)`"
                    />
                  </g>
                </g>
                

                <g
                  v-if="['SN EZ-Flip'].includes(plugTypeSideA)"
                >
                
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [28, 60, 116, 148]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + 4
                      })`"
                    />
                    <component
                      :is="`SNEZFlipPlug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding + 59} ${yOffset - 23}) scale(.6 -.6) rotate(180)`"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['SN EZ-Flip'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.6 .6)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g v-for="yOffset in [60, 116]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + 4
                      })`"
                    />
                    <component
                      :is="`SNEZFlipPlug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 -.6) rotate(-90)`"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    $route.name === 'patch-cord' &&
                    ['MTP12', 'MTP', 'MTP24', 'mtp12', 'mtp', 'mtp24'].includes(plugTypeSideA) &&
                    calculatePlugCount({fiberCount, plugType: plugTypeSideA, plex: plexSideA, cableType: $route.name}) > 0
                  "
                >
                  <!-- Bend protection for MTP cables -->
                  <g v-if="bendProtectionA">
                    <bend-protection
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 50
                      } ${height / 2}) scale(1.4 1.4)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>
                  
                  <!-- MTP12Plug Side A (Left) -->
                  <!-- Positioned on left side using x/y offset-based coordinates -->
                  <!-- No scaling applied - renders at full connector dimensions -->
                  <component
                    :is="`MTP12Plug`"
                    :plug-color="plugColorSideA"
                    :plex="plexSideA"
                    :x="horizontalPadding + offsets['MTP12Plug'].x"
                    :y="height / 2 - offsets['MTP12Plug'].y"
                    ferrule-type="Keramik"
                    politur="APC"
                    farbe="grün"
                    clip-type="ohne"
                  />
                </g>

                <g
                  v-else-if="
                    ['CS'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 20
                      } ${yOffset}) scale(.85 .85)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [33, 65, 121.5, 153.5]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + 4
                      })`"
                    />
                    <component
                      :is="`CsPlug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 -.6) rotate(-90)`"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['CS'].includes(plugTypeSideA) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideA,
                      plex: plexSideA,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionA">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        horizontalPadding + claddingMargin + 16
                      } ${yOffset}) scale(.85 .85)`"
                      :color="bendProtectionA.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [65, 121.5]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${horizontalPadding} ${
                        yOffset + 4
                      })`"
                    />
                    <component
                      :is="`CsPlug`"
                      :plug-color="plugColorSideA"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${horizontalPadding} ${yOffset}) scale(.6 -.6) rotate(-90)`"
                    />
                  </g>
                </g>
              </g>
            </g>

            <g
              class="label-a"
              v-if="$route.name === 'patch-cord' && cableDiameter"
            >
              <g
                class="tuelle-a"
                v-if="cableDiameter.indexOf('1,') === 0 || isDataCenterMode"
              >
                <rect
                  fill="#343434"
                  :x="
                    horizontalPadding +
                    claddingMargin +
                    cloakMargin +
                    80 +
                    2 +
                    (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0)
                  "
                  :width="3"
                  :height="20"
                  :y="height / 2 - 10"
                />
                <rect
                  fill="#343434"
                  :x="
                    horizontalPadding +
                    claddingMargin +
                    cloakMargin +
                    85 +
                    (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0)
                  "
                  :width="sakaLabelWidth - 2"
                  :height="18"
                  :y="height / 2 - 9"
                />
                <saka-label
                  :x="
                    horizontalPadding +
                    claddingMargin +
                    cloakMargin +
                    85 +
                    (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0)
                  "
                  :width="sakaLabelWidth"
                  :y="height / 2 - 8"
                />
                <rect
                  fill="#343434"
                  :x="
                    horizontalPadding +
                    claddingMargin +
                    cloakMargin +
                    80 +
                    sakaLabelWidth +
                    (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0)
                  "
                  :width="3"
                  :height="20"
                  :y="height / 2 - 10"
                />
              </g>
              <saka-label
                v-else
                :x="
                  horizontalPadding +
                  claddingMargin +
                  cloakMargin +
                  85 +
                  (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0)
                "
                :width="sakaLabelWidth"
                :y="height / 2 - 8"
              />
            </g>

            <!-- kundenspezifische Tülle -->
            <g
              class="customer-label-a"
              v-if="
                $route.name === 'patch-cord' &&
                getsPipeLabel &&
                isDataCenterMode
              "
            >
              <g class="tuelle-a">
                <rect
                  fill="#343434"
                  :x="
                    horizontalPadding +
                    claddingMargin +
                    cloakMargin +
                    80 +
                    2 +
                    (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0) +
                    75
                  "
                  :width="3"
                  :height="20"
                  :y="height / 2 - 10"
                />
                <rect
                  fill="#343434"
                  :x="
                    horizontalPadding +
                    claddingMargin +
                    cloakMargin +
                    85 +
                    (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0) +
                    75
                  "
                  :width="sakaLabelWidth - 2"
                  :height="18"
                  :y="height / 2 - 9"
                />
                <rect
                  fill="#fcfcfc "
                  :x="
                    horizontalPadding +
                    claddingMargin +
                    cloakMargin +
                    85 +
                    (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0) +
                    75
                  "
                  :width="sakaLabelWidth - 2 - 2"
                  :height="16"
                  :y="height / 2 - 8"
                />
                <rect
                  fill="#343434"
                  :x="
                    horizontalPadding +
                    claddingMargin +
                    cloakMargin +
                    80 +
                    sakaLabelWidth +
                    (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0) +
                    75
                  "
                  :width="3"
                  :height="20"
                  :y="height / 2 - 10"
                />
              </g>
            </g>

            <g
              class="label-a"
              v-if="
                ($route.name === 'breakout' || $route.name === 'trunk') &&
                fiberCount
              "
            >
              <saka-label
                :x="
                  horizontalPadding +
                  claddingMargin +
                  cloakMargin +
                  145 +
                  (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0)
                "
                :width="sakaLabelWidth"
                :y="height / 2 - 8"
              />
            </g>

            <!-- <custom-label :transform="`
              translate(
                ${horizontalPadding + claddingMargin + cloakMargin + 65 + 65 + 25 
                  + ($route.name === 'patch-cord' ? 0 : 65) 
                  + (plexSideA && plexSideA.endsWith('Tab') ? 40 : 0)} ${height / 2 - 20 / 2})`" 
              :line1="$store.state.customLabelSideA.line1" 
              :line2="$store.state.customLabelSideA.line2"
            /> -->

            <!-- opacity overlay side a -->
            <polygon
              class="overlay"
              v-if="overlay === 'sideA'"
              :points="`0,${height - 25} 0,25        ${
                width / 2 -
                (fiberCount && ['1', '2', '2x1'].includes(fiberCount) ? 40 : 60)
              },25 ${width / 2 + 5},${height / 2 + 6} ${
                width / 2 -
                (fiberCount && ['1', '2', '2x1'].includes(fiberCount) ? 40 : 60)
              },${height - 25}`"
              fill="white"
              opacity=".7"
            />
            <!--      links unten      links oben  rechts oben vor Mitte                                                              Mitte                              rechts unter Mitte -->
          </g>

          <g class="side-b" v-if="!isPigtail">
            <!-- <g class="label-b" v-if="!isPigtail && cableDiameter && !isDataCenterMode">
              <g class="tuelle-b" v-if="isDataCenterMode || cableDiameter.indexOf('1,') === 0">
                <rect fill="#343434" :x="width- (horizontalPadding + claddingMargin + cloakMargin + 80) - 10 - (plexSideA && plexSideA.endsWith('Tab') ? 40: 0)" :width="3" :height="20" :y="height / 2 - 10" />
                <rect fill="#343434" :x="width - (horizontalPadding + claddingMargin + cloakMargin + 85) - sakaLabelWidth - (plexSideA && plexSideA.endsWith('Tab') ? 40: 0)" :width="sakaLabelWidth - 2" :height=" 18" :y="height / 2 - 9" />
                <saka-label :x="width - (horizontalPadding + claddingMargin + cloakMargin + 85) - sakaLabelWidth - (plexSideA && plexSideA.endsWith('Tab') ? 40: 0)" :width="sakaLabelWidth" :y="height / 2 - 8"/>
                <rect fill="#343434" :x="width - (horizontalPadding + claddingMargin + cloakMargin + 80 + sakaLabelWidth) - 8 - (plexSideA && plexSideA.endsWith('Tab') ? 40: 0)" :width="3" :height="20" :y="height / 2 - 10" />
              </g>
              <saka-label v-else :x="width - (horizontalPadding + claddingMargin + cloakMargin + 85) - sakaLabelWidth - (plexSideA && plexSideA.endsWith('Tab') ? 40: 0)" :width="sakaLabelWidth" :y="height / 2 - 8"/>
            </g> -->

            <g v-if="plugTypeSideB" class="plugs-b configured">
              <g v-if="getEffectiveFiberCountForCable(fiberCount, plugTypeSideA, plugTypeSideB) === '1'">
                <rect
                  class="fiber-overlay"
                  :x="
                    width -
                    (horizontalPadding + fiberOverlayPadding.x) -
                    (claddingMargin + cloakMargin)
                  "
                  :y="
                    height / 2 -
                    offsets[`${plugTypeSideB}Plug`].y -
                    fiberOverlayPadding.y
                  "
                  :height="
                    2 *
                    (offsets[`${plugTypeSideB}Plug`].y + fiberOverlayPadding.y)
                  "
                  :width="claddingMargin + cloakMargin"
                  fill="white"
                />
                <component
                  :is="`${
                    plugTypeSideB.indexOf('FC') === 0
                      ? 'FC'
                      : plugTypeSideB.indexOf('FSMA') === 0
                      ? 'FSMA905Rändel'
                      : plugTypeSideB
                  }Plug`"
                  :x="
                    width -
                    (horizontalPadding + offsets[`${plugTypeSideB}Plug`].x)
                  "
                  :y="height / 2"
                  :plug-color="plugColorSideB"
                  flip
                />

                <bend-protection
                  v-if="bendProtectionB"
                  :transform="`translate(${
                    width - horizontalPadding - claddingMargin - cloakMargin - 5
                  } ${height / 2})`"
                  flip
                  :color="bendProtectionB.colorTop"
                />
              </g>

              <g v-if="getEffectiveFiberCountForCable(fiberCount, plugTypeSideA, plugTypeSideB) === '2'">
                <g v-if="plugTypeSideB === 'MDC'">
                  <g v-if="bendProtectionB">
                    <bend-protection
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 55)
                      } ${height / 2}) scale(1.4 1.4) rotate(180)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="
                      width -
                      (horizontalPadding +
                        fiberOverlayPadding.x +
                        claddingMargin +
                        cloakMargin)
                    "
                    :y="
                      height / 2 +
                      offsets[`${plugTypeSideB}Plug`].y -
                      fiberOverlayPadding.y -
                      15
                    "
                    :height="
                      2 *
                      (offsets[`${plugTypeSideB}Plug`].y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`MDCPlug`"
                    :transform="`translate(${width - horizontalPadding + 3} ${
                      height / 2 + 20
                    }) scale(1 -1) rotate(90)`"
                    :plug-color="plugColorSideB"
                  />
                </g>
                <g v-else-if="plugTypeSideB === 'SN EZ-Flip'">
                  <g v-if="bendProtectionB && bendProtectionB == 'jjh'">
                    <bend-protection
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 55)
                      } ${height / 2}) scale(1.4 1.4) rotate(180)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="horizontalPadding"
                    :y="height / 2 - 58"
                    :width="svgWidth - horizontalPadding * 2"
                    :height="cloakMargin"
                  />
                  <component
                    :is="`SNEZFlipPlug`"
                    :transform="`translate(${width - horizontalPadding - 95} ${
                      height / 2 - 58
                    }) rotate(0)`"
                    :plug-color="plugColorSideB"
                  />
                </g>
                <g v-else-if="plugTypeSideB === 'URM NG P2'">
                  <g v-if="bendProtectionB">
                    <bend-protection
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 40)
                      } ${height / 2}) scale(1.4 1.4) rotate(180)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="width - (horizontalPadding + fiberOverlayPadding.x)"
                    :y="
                      height / 2 +
                      offsets[`${plugTypeSideB}Plug`].y -
                      fiberOverlayPadding.y
                    "
                    :height="
                      2 *
                      (offsets[`${plugTypeSideB}Plug`].y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`UrmP2Plug`"
                    :transform="`translate(${width - horizontalPadding} ${
                      height / 2 - 14
                    }) scale(1.3 1.3) rotate(180)`"
                    :plug-color="plugColorSideB"
                  />
                </g>
                <g
                  v-else-if="
                    ['MTP', 'mtp'].includes(plugTypeSideB)
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 55)
                      } ${height / 2}) scale(1.4 1.4) rotate(180)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="width - (horizontalPadding + fiberOverlayPadding.x)"
                    :y="
                      height / 2 +
                      (
                        offsets[`${plugTypeSideB}Plug`] ||
                        offsets['MTP12Plug']
                      ).y -
                      fiberOverlayPadding.y -
                      15
                    "
                    :height="
                      2 *
                      ((
                        offsets[`${plugTypeSideB}Plug`] ||
                        offsets['MTP12Plug']
                      ).y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`MTP12Plug`"
                    :transform="`translate(${width - horizontalPadding - 15 + 175} ${
                      height / 2
                    }) scale(-0.35 0.35)`"
                    :plug-type="plugTypeSideB"
                    :plex="plexSideB"
                    :plug-color="plugColorSideB"
                    ferrule-type="Keramik"
                    politur="APC"
                    farbe="grün"
                    clip-type="ohne"
                  />
                  
                </g>
                <g v-else-if="plugTypeSideB === 'CS'">
                  <g v-if="bendProtectionB">
                    <bend-protection
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 55)
                      } ${height / 2}) scale(1.4 1.4) rotate(180)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <rect
                    class="fiber-overlay"
                    :x="
                      width -
                      (horizontalPadding +
                        fiberOverlayPadding.x +
                        claddingMargin +
                        cloakMargin)
                    "
                    :y="
                      height / 2 +
                      offsets[`${plugTypeSideB}Plug`].y -
                      fiberOverlayPadding.y -
                      15
                    "
                    :height="
                      2 *
                      (offsets[`${plugTypeSideB}Plug`].y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                  />
                  <component
                    :is="`CsPlug`"
                    :transform="`translate(${width - horizontalPadding + 3} ${
                      height / 2 + 11
                    }) scale(1 -1) rotate(90)`"
                    :plug-color="plugColorSideB"
                  />
                </g>
                <g v-else>
                  <rect
                    class="fiber-overlay"
                    :x="
                      width -
                      (horizontalPadding + fiberOverlayPadding.x) -
                      (claddingMargin + cloakMargin)
                    "
                    :y="
                      height / 2 -
                      offsets[`${plugTypeSideB}Plug`].y -
                      fiberOverlayPadding.y
                    "
                    :height="
                      2 *
                      (offsets[`${plugTypeSideB}Plug`].y +
                        fiberOverlayPadding.y)
                    "
                    :width="claddingMargin + cloakMargin"
                    fill="white"
                    flip
                  />
                  <component
                    :is="`${
                      plugTypeSideB.indexOf('FC') === 0 ? 'FC' : plugTypeSideB
                    }Plug`"
                    :x="
                      width -
                      (horizontalPadding + offsets[`${plugTypeSideB}Plug`].x)
                    "
                    :y="height / 2 - offsets[`${plugTypeSideB}Plug`].y"
                    :plug-color="plugColorSideB"
                    :clip="plexSideB === 'dx'"
                    flip
                  />
                  <component
                    :is="`${
                      plugTypeSideB.indexOf('FC') === 0 ? 'FC' : plugTypeSideB
                    }Plug`"
                    :x="
                      width -
                      (horizontalPadding + offsets[`${plugTypeSideB}Plug`].x)
                    "
                    :y="height / 2 + offsets[`${plugTypeSideB}Plug`].y"
                    :plug-color="plugColorSideB"
                    :clip="plexSideB === 'dx'"
                    flip
                  />

                  <sc-clip
                    v-if="plexSideB === 'dx' && plugTypeSideB === 'SC'"
                    :transform="`translate(${
                      width -
                      (horizontalPadding + claddingMargin + cloakMargin - 4)
                    } ${height / 2 - 47 / 2}) scale(1 1)`"
                    :color="plugColorSideB"
                  />
                  <lc-clip
                    v-if="plexSideB === 'dx' && plugTypeSideB === 'LC'"
                    :transform="`translate(${
                      width - (horizontalPadding - 20)
                    } ${height / 2 - 19}) rotate(90)`"
                    :color="plugColorSideB"
                  />

                  <bend-protection
                    v-if="bendProtectionB"
                    :transform="`translate(${
                      width -
                      horizontalPadding -
                      claddingMargin -
                      cloakMargin -
                      7
                    } ${height / 2})`"
                    flip
                    :scale-y="1.6"
                    :scale-x="1.5"
                    :color="bendProtectionB.colorTop"
                  />

                  <g v-if="plexSideB && plexSideB.indexOf('Secure') > 0">
                    <circle
                      class="lc-secure-clip"
                      cx="0"
                      cy="0"
                      r="16"
                      fill="#d1230c"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 31)
                      } ${height / 2})`"
                    />
                    <lc-clip
                      v-if="plugTypeSideB === 'LC'"
                      :transform="`translate(${
                        width - (horizontalPadding - 20)
                      } ${height / 2 - 19}) rotate(90)`"
                      :color="`rot`"
                    />
                  </g>

                  <clip-tab
                    v-if="plexSideB && plexSideB.endsWith('Tab')"
                    :transform="`translate(${width - horizontalPadding - 110} ${
                      height / 2 + 8
                    }) rotate(180)`"
                  />
                  <lc-uniboot-clip
                    v-if="
                      plexSideB &&
                      plexSideB.indexOf('Uniboot') === 0 &&
                      plexSideB.indexOf('Secure') === -1
                    "
                    :transform="`translate(${width - horizontalPadding - 40} ${
                      height / 2 + 17.5
                    }) rotate(180) scale(3.8 3.8)`"
                    :color="plugColorSideB"
                  />
                </g>
              </g>

              <g v-if="getEffectiveFiberCountForCable(fiberCount, plugTypeSideA, plugTypeSideB) === '2x1'">
                <rect
                  class="fiber-overlay"
                  :x="
                    width -
                    (horizontalPadding + fiberOverlayPadding.x) -
                    (claddingMargin + cloakMargin)
                  "
                  :y="
                    height / 2 -
                    offsets[`${plugTypeSideB}Plug`].y -
                    fiberOverlayPadding.y
                  "
                  :height="
                    2 *
                    (offsets[`${plugTypeSideB}Plug`].y + fiberOverlayPadding.y)
                  "
                  :width="claddingMargin + cloakMargin"
                  fill="white"
                />
                <component
                  :is="`${
                    plugTypeSideB.indexOf('FC') === 0
                      ? 'FC'
                      : plugTypeSideB.indexOf('FSMA') === 0
                      ? 'FSMA905Rändel'
                      : plugTypeSideB
                  }Plug`"
                  :x="
                    width -
                    (horizontalPadding + offsets[`${plugTypeSideB}Plug`].x)
                  "
                  :y="height / 2 - offsets[`${plugTypeSideB}Plug`].y"
                  :plug-color="plugColorSideB"
                  :clip="plexSideB === 'dx'"
                  flip
                />
                <component
                  :is="`${
                    plugTypeSideB.indexOf('FC') === 0
                      ? 'FC'
                      : plugTypeSideB.indexOf('FSMA') === 0
                      ? 'FSMA905Rändel'
                      : plugTypeSideB
                  }Plug`"
                  :x="
                    width -
                    (horizontalPadding + offsets[`${plugTypeSideB}Plug`].x)
                  "
                  :y="height / 2 + offsets[`${plugTypeSideB}Plug`].y"
                  :plug-color="plugColorSideB"
                  :clip="plexSideB === 'dx'"
                  flip
                />

                <sc-clip
                  v-if="plexSideB === 'dx' && plugTypeSideB === 'SC'"
                  :transform="`translate(${
                    width -
                    (horizontalPadding + claddingMargin + cloakMargin - 4)
                  } ${height / 2 - 44 / 2}) scale(1 1)`"
                  :color="plugColorSideB"
                />
                <lc-clip
                  v-if="plexSideB === 'dx' && plugTypeSideB === 'LC'"
                  :transform="`translate(${width - (horizontalPadding - 20)} ${
                    height / 2 - 19
                  }) rotate(90)`"
                  :color="plugColorSideB"
                />

                <g v-if="bendProtectionB">
                  <bend-protection
                    flip
                    :transform="`translate(${
                      width -
                      horizontalPadding -
                      claddingMargin -
                      cloakMargin -
                      3
                    } ${
                      height / 2 -
                      ([
                        'SC',
                        'FC',
                        'ST',
                        'FC Narrow Key',
                        'FSMA 905 Rändel',
                      ].includes(plugTypeSideB)
                        ? 13
                        : 9)
                    })`"
                    :color="bendProtectionB.colorBottom"
                  />
                  <bend-protection
                    flip
                    :transform="`translate(${
                      width -
                      horizontalPadding -
                      claddingMargin -
                      cloakMargin -
                      3
                    } ${
                      height / 2 +
                      ([
                        'SC',
                        'FC',
                        'ST',
                        'FC Narrow Key',
                        'FSMA 905 Rändel',
                      ].includes(plugTypeSideB)
                        ? 13
                        : 9)
                    })`"
                    :color="bendProtectionB.colorTop"
                  />
                </g>
              </g>

              <g
                v-if="
                  [
                    '4',
                    '8',
                    '12',
                    '16',
                    '24',
                    '3x8',
                    '4x8',
                    '6x8',
                    '8x8',
                    '12x8',
                    '16x8',
                    '2x12',
                    '4x12',
                    '6x12',
                    '8x12',
                    '12x12',
                    '16x8',
                    '8x2',
                    '16x2',
                    '24x2',
                  ].includes(fiberCount) || (!isNaN(fiberCount) && parseInt(fiberCount) >= 4)
                "
              >
                <g
                  v-if="
                    ['E2000', 'LC'].includes(plugTypeSideB) &&
                    (plexSideB === 'sx' || !plexSideB)
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [48, 80, 136, 168]"
                    :key="`plug-a-${yOffset}`"
                    :is="`${plugTypeSideB}Plug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) rotate(90) ${
                      plugTypeSideB === 'E2000'
                        ? 'scale(-.6 .6)'
                        : 'scale(-.8 .8)'
                    }`"
                    :plug-color="plugColorSideB"
                    :clip="plexSideB === 'dx'"
                  />
                </g>
                <g
                  v-if="
                    ['FC', 'FC Narrow Key'].includes(plugTypeSideB) &&
                    plexSideB === 'sx'
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [52, 84, 140, 172]"
                    :key="`plug-a-${yOffset}`"
                    :is="`${
                      plugTypeSideB.indexOf('FC') === 0 ? 'FC' : plugTypeSideB
                    }Plug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) rotate(90) scale(-.8 .8)`"
                    :plug-color="plugColorSideB"
                    :clip="plexSideB === 'dx'"
                  />
                </g>
                <g
                  v-if="
                    ['FSMA 905 Rändel'].includes(plugTypeSideB) &&
                    plexSideB === 'sx'
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [67, 99, 155, 186]"
                    :key="`plug-a-${yOffset}`"
                    :is="`FSMA905RaendelPlug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) rotate(90) scale(-.7 .7)`"
                    :plug-color="plugColorSideB"
                    :clip="plexSideB === 'dx'"
                  />
                </g>
                <g v-if="['ST'].includes(plugTypeSideB) && plexSideB === 'sx'">
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [70, 101, 158, 189]"
                    :key="`plug-a-${yOffset}`"
                    :is="`${
                      plugTypeSideB.indexOf('FC') === 0 ? 'FC' : plugTypeSideB
                    }Plug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) rotate(90) scale(-.7 .7)`"
                    :plug-color="plugColorSideB"
                    :clip="plexSideB === 'dx'"
                  />
                </g>
                <g v-if="['DIN'].includes(plugTypeSideB) && plexSideB === 'sx'">
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [47, 78.5, 135.5, 167.5]"
                    :key="`plug-a-${yOffset}`"
                    :is="`DINPlug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) rotate(90) scale(-.7 .7)`"
                    :plug-color="plugColorSideB"
                    :clip="plexSideB === 'dx'"
                  />
                </g>
                <g v-if="['SC'].includes(plugTypeSideB) && plexSideB === 'sx'">
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [49, 81, 137, 169]"
                    :key="`plug-a-${yOffset}`"
                    :is="`${
                      plugTypeSideB.indexOf('FC') === 0 ? 'FC' : plugTypeSideB
                    }Plug`"
                    :x="0"
                    :y="0"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) rotate(90) ${
                      plugTypeSideB === 'SC' ? 'scale(-.6 .6)' : ''
                    }`"
                    :plug-color="plugColorSideB"
                    :clip="plexSideB === 'dx'"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P8'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 1
                  "
                >
                  <bend-protection
                    v-if="bendProtectionB"
                    :x="0"
                    :y="0"
                    flip
                    :transform="`translate(${
                      width - (horizontalPadding + 80)
                    } ${height / 2})`"
                    :color="bendProtectionB.colorTop"
                  />
                  <component
                    :is="`UrmP8Plug`"
                    :transform="`translate(${width - horizontalPadding} ${
                      height / 2 + 19
                    }) scale(-1 1)`"
                    :plug-color="plugColorSideB"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P8'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 72, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :x="0"
                      :y="0"
                      :transform="`translate(${
                        width - (horizontalPadding + 32)
                      } ${yOffset}) scale(-1 1)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [53, 85, 141, 173]"
                    :key="`plug-a-${yOffset}`"
                    :is="`UrmP8Plug`"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) scale(-.65 .65)`"
                    :plug-color="plugColorSideB"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P8'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) == 3
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 72, 128]"
                      :key="`bp-a-${yOffset}`"
                      :x="0"
                      :y="0"
                      :transform="`translate(${
                        width - (horizontalPadding + 32)
                      } ${yOffset}) scale(-1 1)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [53, 85, 141]"
                    :key="`plug-a-${yOffset}`"
                    :is="`UrmP8Plug`"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) scale(-.65 .65)`"
                    :plug-color="plugColorSideB"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P2'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [52, 83, 140, 171]"
                    :key="`plug-b-${yOffset}`"
                    :is="`UrmP2Plug`"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) scale(-1 1)`"
                    :plug-color="plugColorSideB"
                  />
                </g>

                <g
                  v-if="
                    ['URM NG P2'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <component
                    v-for="yOffset in [83, 140]"
                    :key="`plug-b-${yOffset}`"
                    :is="`UrmP2Plug`"
                    :transform="`translate(${
                      width - horizontalPadding
                    } ${yOffset}) scale(-1 1)`"
                    :plug-color="plugColorSideB"
                  />
                </g>

                <g
                  v-if="
                    ['LC'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4 &&
                    plexSideB === 'dx'
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [
                        35, 45, 66.5, 76.5, 123, 133, 155, 165,
                      ]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + (plugTypeSideB === 'LC' ? 12 : 14)
                      }) scale(-.6 .6) rotate(-90)`"
                    />
                    <lc-clip
                      v-if="plugTypeSideB === 'LC'"
                      :transform="`translate(${
                        width - (horizontalPadding - 12)
                      } ${yOffset + 11}) scale(-.6 .6) rotate(-90)`"
                      :color="plugColorSideB"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['LC'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2 &&
                    plexSideB === 'dx'
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [66.5, 76.5, 123, 133]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g v-for="yOffset in [72, 128]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + (plugTypeSideB === 'LC' ? 12 : 14)
                      }) scale(-.6 .6) rotate(-90)`"
                    />
                    <lc-clip
                      v-if="plugTypeSideB === 'LC'"
                      :transform="`translate(${
                        width - (horizontalPadding - 12)
                      } ${yOffset + 11}) scale(-.6 .6) rotate(-90)`"
                      :color="plugColorSideB"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['E2000'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4 &&
                    plexSideB === 'dx'
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [
                        35, 45, 66.5, 76.5, 123, 133, 155, 165,
                      ]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.5 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + 14
                      }) scale(-.5 .6) rotate(-90)`"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['E2000'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2 &&
                    plexSideB === 'dx'
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [66.5, 76.5, 123, 133]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g v-for="yOffset in [72, 128]" :key="`plug-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.5 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + 14
                      }) scale(-.5 .6) rotate(-90)`"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['SC'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4 &&
                    plexSideB === 'dx'
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [
                        35, 45, 66.5, 76.5, 123, 133, 155, 165,
                      ]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [39, 71, 127, 159]"
                    :key="`bp-a-dx-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="20"
                      fill="white"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset - 13
                      })`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.4 .4) rotate(-90)`"
                    />

                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + 14
                      }) scale(-.4 .4) rotate(-90)`"
                    />
                    <sc-clip
                      v-if="plugTypeSideB === 'SC'"
                      :transform="`translate(${
                        width - (horizontalPadding + 25)
                      } ${yOffset - 13}) scale(-.6 .6)`"
                      :color="plugColorSideB"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['SC'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2 &&
                    plexSideB === 'dx'
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [66.5, 76.5, 123, 133]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g v-for="yOffset in [71, 127]" :key="`bp-a-dx-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="20"
                      fill="white"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset - 13
                      })`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.4 .4) rotate(-90)`"
                    />

                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + 14
                      }) scale(-.4 .4) rotate(-90)`"
                    />
                    <sc-clip
                      v-if="plugTypeSideB === 'SC'"
                      :transform="`translate(${
                        width - (horizontalPadding + 25)
                      } ${yOffset - 13}) scale(-.6 .6)`"
                      :color="plugColorSideB"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideB) &&
                    plexSideB.indexOf('Tab') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [40, 71.5, 128, 160]"
                      :key="`bp-b-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-b-uni-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - (horizontalPadding + 30)
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + (plugTypeSideB === 'LC' ? 12 : 14)
                      }) scale(-.6 .6) rotate(-90)`"
                    />
                    <clip-tab
                      v-if="plexSideB && plexSideB.indexOf('Tab') > 0"
                      :transform="`translate(${
                        width - (horizontalPadding + 35)
                      } ${yOffset - 6}) scale(-.75 .75)`"
                    />
                    <lc-uniboot-clip
                      v-if="plexSideB && plexSideB.indexOf('Uniboot') === 0"
                      :transform="`translate(${
                        width - (horizontalPadding + 20)
                      } ${yOffset - 11}) scale(-2.3 2.3)`"
                      :color="plugColorSideB"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideB) &&
                    plexSideB.indexOf('Secure') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [40, 71.5, 128, 160]"
                      :key="`bp-b-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-b-uni-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - (horizontalPadding + 30)
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + (plugTypeSideB === 'LC' ? 12 : 14)
                      }) scale(-.6 .6) rotate(-90)`"
                    />
                    <circle
                      class="lc-secure-clip"
                      cx="0"
                      cy="0"
                      r="10"
                      fill="#d1230c"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 5)
                      } ${yOffset})`"
                    />
                    <lc-clip
                      v-if="plugTypeSideB === 'LC'"
                      :transform="`translate(${
                        width - (horizontalPadding - 12)
                      } ${yOffset + 11}) scale(-.6 .6) rotate(-90)`"
                      :color="`red`"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['LC'].includes(plugTypeSideB) &&
                    plexSideB.indexOf('Tab') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-b-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [72, 128]"
                    :key="`plug-b-uni-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - (horizontalPadding + 30)
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + (plugTypeSideB === 'LC' ? 12 : 14)
                      }) scale(-.6 .6) rotate(-90)`"
                    />
                    <clip-tab
                      v-if="plexSideB && plexSideB.indexOf('Tab') > 0"
                      :transform="`translate(${
                        width - (horizontalPadding + 35)
                      } ${yOffset - 6}) scale(-.75 .75)`"
                    />
                    <lc-uniboot-clip
                      v-if="plexSideB && plexSideB.indexOf('Uniboot') === 0"
                      :transform="`translate(${
                        width - (horizontalPadding + 20)
                      } ${yOffset - 11}) scale(-2.3 2.3)`"
                      :color="plugColorSideB"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['LC'].includes(plugTypeSideB) &&
                    plexSideB.indexOf('Secure') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-b-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [72, 128]"
                    :key="`plug-b-uni-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - (horizontalPadding + 30)
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + (plugTypeSideB === 'LC' ? 12 : 14)
                      }) scale(-.6 .6) rotate(-90)`"
                    />
                    <circle
                      class="lc-secure-clip"
                      cx="0"
                      cy="0"
                      r="10"
                      fill="#d1230c"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 5)
                      } ${yOffset})`"
                    />
                    <lc-clip
                      v-if="plugTypeSideB === 'LC'"
                      :transform="`translate(${
                        width - (horizontalPadding - 12)
                      } ${yOffset + 11}) scale(-.6 .6) rotate(-90)`"
                      :color="`red`"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideB) &&
                    plexSideB.indexOf('PRO') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="(yOffset, i) in [40, 71.5, 128, 160]"
                      :key="`bp-b-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="
                        bendProtectionB.colorTop !==
                          bendProtectionB.colorBottom && i % 2 === 0
                          ? bendProtectionB.colorBottom
                          : bendProtectionB.colorTop
                      "
                    />
                  </g>

                  <g
                    v-for="yOffset in [40, 72, 128, 160]"
                    :key="`plug-b-uni-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - (horizontalPadding + 30)
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + (plugTypeSideB === 'LC' ? 12 : 14)
                      }) scale(-.6 .6) rotate(-90)`"
                    />
                    <lc-uniboot-clip
                      v-if="plexSideB && plexSideB.indexOf('Uniboot') === 0"
                      :transform="`translate(${
                        width - (horizontalPadding + 20)
                      } ${yOffset - 11}) scale(-2.3 2.3)`"
                      :color="plugColorSideB"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    ['LC'].includes(plugTypeSideB) &&
                    plexSideB.indexOf('PRO') > 0 &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-b-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 12)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>

                  <g
                    v-for="yOffset in [72, 128]"
                    :key="`plug-b-uni-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - (horizontalPadding + 30)
                      } ${yOffset})`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(-90)`"
                    />
                    <component
                      :is="`${plugTypeSideB}Plug`"
                      :plug-color="plugColorSideB"
                      :clip="true"
                      :x="20"
                      :y="horizontalPadding * 2 - 10"
                      :transform="`translate(${width - horizontalPadding} ${
                        yOffset + (plugTypeSideB === 'LC' ? 12 : 14)
                      }) scale(-.6 .6) rotate(-90)`"
                    />
                    <lc-uniboot-clip
                      v-if="plexSideB && plexSideB.indexOf('Uniboot') === 0"
                      :transform="`translate(${
                        width - (horizontalPadding + 20)
                      } ${yOffset - 11}) scale(-2.3 2.3)`"
                      :color="plugColorSideB"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['MDC'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <g
                    v-for="yOffset in [52, 83, 140, 171]"
                    :key="`plug-b-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding - 30
                      } ${yOffset - 20})`"
                    />
                    <component
                      :is="`MDCPlug`"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(270)`"
                      :plug-color="plugColorSideB"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['MDC'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <g v-for="yOffset in [83, 140]" :key="`plug-b-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding - 30
                      } ${yOffset - 20})`"
                    />
                    <component
                      :is="`MDCPlug`"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(270)`"
                      :plug-color="plugColorSideB"
                    />
                  </g>
                </g>
        
                <g
                  v-if="
                    ['SN EZ-Flip'].includes(plugTypeSideB)"
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <g
                    v-for="yOffset in [52, 83, 140, 171]"
                    :key="`plug-b-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding - 30
                      } ${yOffset - 20})`"
                    />
                    <component
                      :is="`SNEZFlipPlug`"
                      :transform="`translate(${
                        width - horizontalPadding - 60
                      } ${yOffset + 23}) scale(-.6 .6) rotate(180)`"
                      :plug-color="plugColorSideB"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['SN EZ-Flip'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 20)
                      } ${yOffset}) scale(-.6 .6)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <g v-for="yOffset in [83, 140]" :key="`plug-b-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding - 30
                      } ${yOffset - 20})`"
                    />
                    <component
                      :is="`SNEZFlipPlug`"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(270)`"
                      :plug-color="plugColorSideB"
                    />
                  </g>
                </g>
                <g
                  v-if="
                    $route.name === 'patch-cord' &&
                    ['MTP12', 'MTP', 'MTP24', 'mtp12', 'mtp', 'mtp24'].includes(plugTypeSideB) &&
                    calculatePlugCount({fiberCount, plugType: plugTypeSideB, plex: plexSideB, cableType: $route.name}) > 0
                  "
                >
                  <!-- Bend protection for MTP cables -->
                  <g v-if="bendProtectionB">
                    <bend-protection
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 50)
                      } ${height / 2}) scale(-1.4 1.4)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  
                  <!-- MTP12Plug Side B (Right) -->
                  <!-- Positioned on right side using transform translate + scale -->
                  <!-- scale(-0.35 0.35): Negative x-scale mirrors horizontally; y-scale 0.35 reduces vertical size -->
                  <!-- translate: Places connector at right edge; compensates for origin shift from negative scale -->
                  <component
                  :is="`MTP12Plug`"
                  :plug-color="plugColorSideB"
                  :plex="plexSideB"
                  :x="horizontalPadding + offsets['MTP12Plug'].x"
                  :y="height / 2 - offsets['MTP12Plug'].y"
                  ferrule-type="Keramik"
                  politur="APC"
                  farbe="grün"
                  clip-type="ohne"
                  :transform="`translate(${width}, 0) scale(-1, 1)`"
                />
                  
                </g>

                <g
                  v-if="
                    ['CS'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) >= 4
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [40, 71.5, 128, 160]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 16)
                      } ${yOffset}) scale(-.85 .85)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <g
                    v-for="yOffset in [47, 78, 135, 166]"
                    :key="`plug-b-${yOffset}`"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding - 30
                      } ${yOffset - 12})`"
                    />
                    <component
                      :is="`CsPlug`"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(270)`"
                      :plug-color="plugColorSideB"
                    />
                  </g>
                </g>

                <g
                  v-if="
                    ['CS'].includes(plugTypeSideB) &&
                    calculatePlugCount({
                      fiberCount,
                      plugType: plugTypeSideB,
                      plex: plexSideB,
                    }) === 2
                  "
                >
                  <g v-if="bendProtectionB">
                    <bend-protection
                      v-for="yOffset in [71.5, 128]"
                      :key="`bp-a-${yOffset}`"
                      :transform="`translate(${
                        width - (horizontalPadding + claddingMargin + 16)
                      } ${yOffset}) scale(-.85 .85)`"
                      :color="bendProtectionB.colorTop"
                    />
                  </g>
                  <g v-for="yOffset in [78, 135]" :key="`plug-b-${yOffset}`">
                    <rect
                      x="0"
                      y="0"
                      width="30"
                      height="12"
                      fill="white"
                      :transform="`translate(${
                        width - horizontalPadding - 20
                      } ${yOffset - 12})`"
                    />
                    <component
                      :is="`CsPlug`"
                      :transform="`translate(${
                        width - horizontalPadding
                      } ${yOffset}) scale(-.6 .6) rotate(270)`"
                      :plug-color="plugColorSideB"
                    />
                  </g>
                </g>
              </g>
              <g
                class="label-b"
                v-if="$route.name === 'patch-cord' && cableDiameter"
              >
                <g
                  class="tuelle-b"
                  v-if="isDataCenterMode || cableDiameter.indexOf('1,') === 0"
                >
                  <rect
                    fill="#343434"
                    :x="
                      width -
                      (horizontalPadding + claddingMargin + cloakMargin + 80) -
                      10 -
                      (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                    "
                    :width="3"
                    :height="20"
                    :y="height / 2 - 10"
                  />
                  <rect
                    fill="#343434"
                    :x="
                      width -
                      (horizontalPadding + claddingMargin + cloakMargin + 85) -
                      sakaLabelWidth -
                      (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                    "
                    :width="sakaLabelWidth - 2"
                    :height="18"
                    :y="height / 2 - 9"
                  />
                  <saka-label
                    :x="
                      width -
                      (horizontalPadding + claddingMargin + cloakMargin + 85) -
                      sakaLabelWidth -
                      (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                    "
                    :width="sakaLabelWidth"
                    :y="height / 2 - 8"
                  />
                  <rect
                    fill="#343434"
                    :x="
                      width -
                      (horizontalPadding +
                        claddingMargin +
                        cloakMargin +
                        80 +
                        sakaLabelWidth) -
                      8 -
                      (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                    "
                    :width="3"
                    :height="20"
                    :y="height / 2 - 10"
                  />
                </g>
                <saka-label
                  v-else
                  :x="
                    width -
                    (horizontalPadding + claddingMargin + cloakMargin + 85) -
                    sakaLabelWidth -
                    (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                  "
                  :width="sakaLabelWidth"
                  :y="height / 2 - 8"
                />
              </g>

              <!-- kundenspezifische Tülle -->
              <g
                class="label-b"
                v-if="
                  $route.name === 'patch-cord' &&
                  getsPipeLabel &&
                  isDataCenterMode
                "
              >
                <g class="tuelle-b">
                  <rect
                    fill="#343434"
                    :x="
                      width -
                      (horizontalPadding + claddingMargin + cloakMargin + 80) -
                      10 -
                      (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0) -
                      75
                    "
                    :width="3"
                    :height="20"
                    :y="height / 2 - 10"
                  />
                  <rect
                    fill="#343434"
                    :x="
                      width -
                      (horizontalPadding + claddingMargin + cloakMargin + 85) -
                      sakaLabelWidth -
                      (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0) -
                      75
                    "
                    :width="sakaLabelWidth - 2"
                    :height="18"
                    :y="height / 2 - 9"
                  />
                  <rect
                    fill="#fcfcfc"
                    :x="
                      width -
                      (horizontalPadding + claddingMargin + cloakMargin + 85) -
                      sakaLabelWidth -
                      (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0) -
                      75
                    "
                    :width="sakaLabelWidth - 2 - 2"
                    :height="16"
                    :y="height / 2 - 8"
                  />
                  <rect
                    fill="#343434"
                    :x="
                      width -
                      (horizontalPadding +
                        claddingMargin +
                        cloakMargin +
                        80 +
                        sakaLabelWidth) -
                      8 -
                      (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0) -
                      75
                    "
                    :width="3"
                    :height="20"
                    :y="height / 2 - 10"
                  />
                </g>
              </g>

              <!-- <custom-label 
                @custom-label-width="$store.commit('setState', {stateKey: 'customLabelBX', data: width - (horizontalPadding + claddingMargin + cloakMargin + 167) - $event})" 
                :transform="`
                  translate(${customLabelBX > 320 
                    ? (customLabelBX + ($route.name === 'patch-cord' ? 0 : -65) + (plexSideB && plexSideB.endsWith('Tab') ? -40 : 0)) 
                    : (width - (horizontalPadding + claddingMargin + cloakMargin + 65 + 65 + 75 + 10 + ($route.name === 'patch-cord' ? 0 : 75) + (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)))} ${height / 2 - 20 / 2})`" 
                :line1="$store.state.customLabelSideB.line1" 
                :line2="$store.state.customLabelSideB.line2"/> -->
            </g>
            <g
              class="label-b"
              v-if="$route.name === 'patch-cord' && cableDiameter"
            >
              <g
                class="tuelle-b"
                v-if="isDataCenterMode || cableDiameter.indexOf('1,') === 0"
              >
                <rect
                  fill="#343434"
                  :x="
                    width -
                    (horizontalPadding + claddingMargin + cloakMargin + 80) -
                    10 -
                    (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                  "
                  :width="3"
                  :height="20"
                  :y="height / 2 - 10"
                />
                <rect
                  fill="#343434"
                  :x="
                    width -
                    (horizontalPadding + claddingMargin + cloakMargin + 85) -
                    sakaLabelWidth -
                    (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                  "
                  :width="sakaLabelWidth - 2"
                  :height="18"
                  :y="height / 2 - 9"
                />
                <saka-label
                  :x="
                    width -
                    (horizontalPadding + claddingMargin + cloakMargin + 85) -
                    sakaLabelWidth -
                    (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                  "
                  :width="sakaLabelWidth"
                  :y="height / 2 - 8"
                />
                <rect
                  fill="#343434"
                  :x="
                    width -
                    (horizontalPadding +
                      claddingMargin +
                      cloakMargin +
                      80 +
                      sakaLabelWidth) -
                    8 -
                    (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                  "
                  :width="3"
                  :height="20"
                  :y="height / 2 - 10"
                />
              </g>
              <saka-label
                v-else
                :x="
                  width -
                  (horizontalPadding + claddingMargin + cloakMargin + 85) -
                  sakaLabelWidth -
                  (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                "
                :width="sakaLabelWidth"
                :y="height / 2 - 8"
              />
            </g>

            <g
              class="label-b"
              v-if="
                ($route.name === 'trunk' || $route.name === 'breakout') &&
                fiberCount
              "
            >
              <saka-label
                :x="
                  width -
                  (horizontalPadding + claddingMargin + cloakMargin + 145) -
                  sakaLabelWidth -
                  (plexSideB && plexSideB.endsWith('Tab') ? 40 : 0)
                "
                :width="sakaLabelWidth"
                :y="height / 2 - 8"
              />
            </g>

            <!-- opacity overlay side b -->
            <polygon
              v-if="overlay === 'sideB'"
              class="ueber"
              :points="`${width},${height - 25} ${width},25 ${
                width / 2 +
                (fiberCount && ['1', '2', '2x1'].includes(fiberCount) ? 40 : 60)
              },25 ${width / 2 - 4},${height / 2 - 6} ${
                width / 2 +
                (fiberCount && ['1', '2', '2x1'].includes(fiberCount) ? 40 : 60)
              },${height - 25}`"
              fill="white"
              opacity=".7"
            />
            <!--      rechts unten            rechts oben links oben vor Mitte                                                 Mitte                              links unter Mitte -->
          </g>

          <!-- <g v-else ><text :fill="cssVariables.sakaGrey" text-anchor="middle" :x="(width / 4) * 3" :y="height / 2" font-family="sans-serif">{{ $t('productCanvas.isPigtail') }}</text></g> -->

          <canvas-legend
            :svg-width="width"
            :svg-padding="horizontalPadding"
            :svg-height="height"
            :is-pigtail="false"
          />
          <mid-indicator
            :cable-color="cableColor"
            :svg-height="height"
            :svg-width="width"
            :is-pigtail="isPigtail"
          />
        </g>
      </svg>
    </product-configuration>
  </div>
</template>

<script>
import CanvasLegend from "./CanvasLegend";
import MidIndicator from "./MidIndicator";
import ProductConfiguration from "./ProductConfiguration";
import NoFiberCountHint from "./NoFiberCountHint";
import BaseCable from "./BaseCable";
import LCPlug from "./LcPlug";
import SCPlug from "./ScPlug";
import STPlug from "./StPlug";
import FCPlug from "./FcPlug";
import E2000Plug from "./E2000Plug";
import DINPlug from "./DinPlug";
import SakaLabel from "./SakaLabel";
import CustomLabel from "./CustomLabel";
import BendProtection from "./BendProtection";
import ScClip from "./ScClip";
import LcClip from "./LcClip";
import LcUnibootClip from "./LcUnibootClip";
import ClipTab from "./ClipTab";
import UrmP2Plug from "./UrmP2Plug";
import UrmP8Plug from "./UrmP8Plug";
import FSMA905RaendelPlug from "./FSMA905RaendelPlug";
import calculatePlugCountFn from "@/utils/calculate-plug-count";

// start mdc
import MDCPlug from "./MdcPlug";
import CsPlug from "./CsPlug";

//SNEZFlipPlug
import SNEZFlipPlug from "./SNEZFlipPlug";

// start mtp
import MTP12Plug from "./MTP12Plug";

import { mapState, mapGetters } from "vuex";
import variables from "@/variables.scss";

export default {
  props: {
    height: {
      type: Number,
      default: 140,
    },
    isPigtail: {
      type: Boolean,
      default: false,
    },
    overlay: {
      type: String,
      default: null,
    },
    thickness: {
      type: String,
      default: null,
    },
    overrideProductWidth: {
      type: Boolean,
      default: false,
    },
    svgId: {
      type: String,
      default: `product`,
    },
  },
  components: {
    CanvasLegend,
    MidIndicator,
    BaseCable,
    NoFiberCountHint,
    ProductConfiguration,
    LCPlug,
    SCPlug,
    STPlug,
    FCPlug,
    E2000Plug,
    DINPlug,
    SakaLabel,
    BendProtection,
    LcClip,
    ScClip,
    CustomLabel,
    LcUnibootClip,
    ClipTab,
    UrmP2Plug,
    UrmP8Plug,
    MDCPlug,
    FSMA905RaendelPlug,
    CsPlug,
    SNEZFlipPlug,
    MTP12Plug,
    MTP24Plug: MTP12Plug,
  },
  computed: {
    ...mapState({
      horizontalPadding: (state) => state.svgDefaults.horizontalPadding,
      claddingMargin: (state) => state.svgDefaults.claddingOffset,
      cloakMargin: (state) => state.svgDefaults.cloakOffset,
      customLabelBX: (state) => state.customLabelBX,
      cableLength: (state) => state.cableLength,
      isDataCenterMode: (state) => state.getsDataCenterProducts,
      getsPipeLabel: (state) => state.filters.labels.id === "YA03-0003",
    }),
    ...mapGetters({
      getCssColor: "getCssColor",
    }),
  },
  data() {
    return {
      width: 800,
      resizeListener: null,
      svgWidth: 40,
      offsets: {
        LCPlug: {
          x: 7,
          y: 9,
        },
        SCPlug: {
          x: 7,
          y: 12.5,
        },
        E2000Plug: {
          x: 7,
          y: 9,
        },
        FCPlug: {
          x: 3,
          y: 12.5,
        },
        "FC Narrow KeyPlug": {
          x: 3,
          y: 12.5,
        },
        STPlug: {
          x: 8,
          y: 12.5,
        },
        DINPlug: {
          x: 7,
          y: 10,
        },
        "URM NG P2Plug": {
          x: 7,
          y: 10,
        },
        MDCPlug: {
          x: 7,
          y: 9,
        },
        "FSMA 905 RändelPlug": {
          x: 0,
          y: 15.5,
        },
        CSPlug: {
          x: 7,
          y: 9,
        },
        SNEZFlipPlug: {
          x: 0,
          y: 15.5,
        },
        MTPPlug: {
          x: 0,
          y: 38,
        },
        MTP12Plug: {
          x: -0.01,
          y: 38,
        },
        MTP24Plug: {
          x: -0.01,
          y: 38,
        },
      },
      fiberOverlayPadding: {
        x: -2,
        y: 5,
      },
      sakaLabelWidth: 65,
      cssVariables: variables,
      localWidth: this.width,
    };
  },
  mounted() {
    this.resizeListener = window.addEventListener("resize", this.trySetWidth);
    this.trySetWidth();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.trySetWidth);
  },
  methods: {
    trySetWidth() {
      try {
        // try to fit the screen but not get lower then 800px image width to produce a good data sheet image
        if (
          this.$refs.canvas &&
          this.$refs.canvas.offsetWidth &&
          this.$refs.canvas.offsetWidth <= 768
        ) {
          this.width = 800;
          this.localWidth = this.width;
        } else {
          this.width = this.$refs.canvas.offsetWidth;
          this.localWidth = this.width;
        }
      } catch (ex) {
        // continue regardless of error
      }
    },
    calculatePlugCount: function({ fiberCount, plugType, plex }) {
      return calculatePlugCountFn({
        fiberCount,
        plugType,
        plex,
        cableType: this.$route.name,
      });
    },
    getMTP12Offsets(count) {
      if (!count || count < 1) return [];
      const baseOffsets = [40, 72, 104, 136, 168, 200, 232, 264, 296, 328, 360, 392];
      return baseOffsets.slice(0, count);
    },
    /**
     * Get effective fiber count for cable rendering.
     * For MTP/MTP12 in patch-cord mode, render as single cable (fiberCount=1)
     * instead of breakout fanout visualization.
     * Other cable types and routes use normal fiber count.
     */
    getEffectiveFiberCountForCable(fiberCount, plugTypeSideA, plugTypeSideB) {
      // MTP patch cable special mode: force single cable visualization
      const isMTPPatchMode = 
        this.$route.name === 'patch-cord' && 
        (
          (plugTypeSideA && ['MTP', 'MTP12', 'MTP24', 'mtp', 'mtp12', 'mtp24'].includes(plugTypeSideA)) ||
          (plugTypeSideB && ['MTP', 'MTP12', 'MTP24', 'mtp', 'mtp12', 'mtp24'].includes(plugTypeSideB))
        );
      
      // Patch-cord with 12 or 24 fibers: render as single cable with 1 connector per side
      const isFiberCount12PatchMode =
        this.$route.name === 'patch-cord' &&
        fiberCount === '12';

      const isFiberCount24PatchMode =
        this.$route.name === 'patch-cord' &&
        fiberCount === '24';

      if (isMTPPatchMode || isFiberCount12PatchMode || isFiberCount24PatchMode) {
        return '1';
      }
      
      return fiberCount;
    },
  },
  watch: {
    overrideProductWidth(newVal) {
      if (newVal === true) {
        this.localWidth = this.width;
        this.width = 800;
      }

      if (newVal === false) {
        this.width = this.localWidth;
      }
    },
  },
};
</script>

<style></style>

